import { authRoles } from 'app/auth';
import FeladatCsoportTable from 'app/admin/feladatCsoport/table/FeladatCsoportTable';
import FeladatCsoportEditForm from 'app/admin/feladatCsoport/editform/FeladatCsoportEditForm';

export default [
	{
		path: '/feladat-csoport/edit/:id',
		component: FeladatCsoportEditForm,
		auth: authRoles.admin
	},
	{
		path: '/feladat-csoport/:sessionNameParam?',
		component: FeladatCsoportTable,
		auth: authRoles.admin
	}
];